// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"enter"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5.75 16H16C17.6569 16 19 14.6569 19 13L19 5M8 12.5L4.5 16L8 19.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const EnterIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'enter',
    ref,
    icon: element,
  },
));

EnterIcon.displayName = 'EnterIcon';

export default EnterIcon;
